import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'
import {setupStore} from "./store"
import {Provider} from "react-redux"
import './styles/_index.scss'

const store = setupStore()

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
)
root.render(
  <Provider store={store}>
    <App/>
  </Provider>
)